<template>
  <el-dialog
    :title="profile.id ? 'Редактирование профиля' : 'Создание профиля'"
    :visible.sync="show"
    top="2vh"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      ref="editForm"
      label-position="top"
      :model="profile"
      :rules="profileRules"
      @submit.native.prevent="saveProfile"
    >
      <el-form-item label="Название" prop="name">
        <el-input
          maxlength="1000"
          v-model="profile.name"
          ref="profileToFocus"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="Описание" prop="description">
        <el-input
          maxlength="10000"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6}"
          v-model="profile.description"
        ></el-input>
      </el-form-item>
      <el-switch
        v-model="profile.disabled"
        :active-value="false"
        :inactive-value="true"
        active-text="Активен"
      >
      </el-switch>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">Отмена</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="loading"
        @click="saveProfile"
      > Сохранить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "profile-edit-dialog",
  data() {
    return {
      show: false,
      loading: false,
      profile: {
        id: null,
        name: null,
        description: '',
        disabled: false,
      },
      profileRules: {
        name: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'blur'}],
      },
    }
  },
  methods: {
    async open(profile) {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }

      this.profile = Object.assign({}, profile);
      this.show = true;
      this.$nextTick(() => this.$refs.profileToFocus.focus());
    },
    close() {
      this.show = false;
    },
    saveProfile() {
      if (this.profile.id) {
        this.updateProfile();
      } else {
        this.createProfile();
      }
    },
    createProfile() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.profileCreate({
          name: this.profile.name,
          description: this.profile.description,
          disabled: this.profile.disabled,
        })
          .then(data => {
            this.$notify.success({
              title: 'Сохранено',
              message: 'Профиль успешно создан'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('profile-saved');
          })
      })
    },
    updateProfile() {
      this.$refs.editForm.validate().then(()=> {
        this.loading = true;
        this.$api.evaluation.profileUpdate({
          id: this.profile.id,
          name: this.profile.name,
          description: this.profile.description,
          disabled: this.profile.disabled,
        })
          .then(data => {
            this.$notify.success({
              title: 'Обновлено',
              message: 'Профиль успешно обновлен'
            });
          })
          .finally(()=>{
            this.loading = false;
            this.close();
            this.$emit('profile-saved');
          })
      })
    }
  }
}
</script>

<style scoped>

</style>